import * as React from 'react';
import Axios from 'axios';

import errorReporter from '@app/errorReporter';

interface AddBrokerageGroupInputProps {
  fetchGroups: (setFetching?: boolean) => void;
}

interface AddBrokerageGroupInputState {
  input: string;
  pending: boolean;
}

class AddBrokerageGroupInput extends React.Component<
  AddBrokerageGroupInputProps,
  AddBrokerageGroupInputState
> {
  constructor(props: AddBrokerageGroupInputProps) {
    super(props);
    this.state = {
      input: '',
      pending: false,
    };
  }

  public handleInput = (ev: React.ChangeEvent<HTMLInputElement>) =>
    this.setState({ input: ev.target.value });

  public handleAddGroup = async () => {
    const { input } = this.state;
    const { fetchGroups } = this.props;

    try {
      this.setState({ pending: true });
      await Axios.post('/answering/create_group', { label: input });
      await fetchGroups();
    } catch (err) {
      errorReporter.error(`Error adding a group: ${err}`);
    } finally {
      this.setState({ input: '', pending: false });
    }
  };

  public render() {
    const { input, pending } = this.state;
    return (
      <>
        <form action="" className="input-group" style={{ width: '100%' }}>
          <input
            className="form-control"
            disabled={pending}
            onChange={this.handleInput}
            placeholder="Enter Group Name"
            value={input}
          />
          <span className="input-group-btn">
            <button
              className="btn btn-primary"
              disabled={pending || !input}
              onClick={this.handleAddGroup}
              type="submit"
            >
              {pending ? (
                <>
                  <i className="fa fa-cog fa-spin"></i>
                  <span> RESOLVING...</span>
                </>
              ) : (
                <>
                  <i className="fa fa-plus"></i>
                  <span> ADD GROUP</span>
                </>
              )}
            </button>
          </span>
        </form>
      </>
    );
  }
}

export default AddBrokerageGroupInput;
